module.exports = __webpack_public_path__ + "static/media/profile-picture-7.6c9282c3.jpg";